import { Control, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import "./index.css";
import { DeferReplacementFormValue } from "../../DeferReplacementForm/DeferReplacementForm";

type Props = {
  control: Control<DeferReplacementFormValue, any>;
  error: boolean;
};

export default function ReasonInput<TFieldArrayValues>({
  control,
  error,
}: Props) {
  return (
    <Controller
      rules={{
        required: false,
        maxLength: {
          value: 4000,
          message: "The input must not exceed 4000 characters.",
        },
      }}
      render={({ field }) => (
        <TextField
          error={error}
          helperText={error ? "The input must not exceed 4000 characters." : ""}
          sx={{
            width: "50%",
            "&:hover": {
              color: "primary.main",
            },
          }}
          {...field}
          id="reason-input"
          label={"Write reason"}
          multiline
          rows={3}
          variant="standard"
        />
      )}
      name={"input"}
      control={control}
    />
  );
}
